import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialogModule,
    MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

export interface CsvValuesDialogData {
  columnName: string;
  values: string[];
  maxValues: number;
}

@Component({
  selector: 'app-csv-values-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    NgxDatatableModule
  ],
  templateUrl: './csv-values-dialog.component.html',
  styleUrls: ['./csv-values-dialog.component.css']
})
export class CsvValuesDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: CsvValuesDialogData,
    private dialogRef: MatDialogRef<CsvValuesDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get hasTooManyValues(): boolean {
    return this.data.values.length > this.data.maxValues;
  }

  get hasValues(): boolean {
    return this.data.values.length > 0;
  }

  get rows(): { value: string }[] {
    return this.data.values.map(v => ({ value: v }));
  }
}